import { cls } from "app/utils";
import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";

interface DropdownProps {
  children: React.ReactNode;
  btnContent: React.ReactNode;
  btnClassName?: string;
  dropdownClassname?: string;
  dropdownWrapperClass?: string;
  hideButtonStyles?: boolean;
  closeOnClick?: boolean;
  closeModal?: any;
}

const Dropdown = ({
  children,
  btnContent,
  btnClassName,
  dropdownClassname,
  dropdownWrapperClass,
  hideButtonStyles,
  closeOnClick = false,
  closeModal,
}: DropdownProps) => {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClickOutside = (e: any) => {
    if (isOpen && ref.current && !ref.current.contains(e.target)) {
      if (
        !ref.current.contains(e.target) &&
        !e.target.closest(`.${styles.dropdown_container}`)
      ) {
        setIsOpen(false);
      }
      if (closeOnClick) {
        setIsOpen(false);
      }
    }
  };

  const toggleDropDown = (evt: React.MouseEvent<HTMLSpanElement>) => {
    evt.preventDefault();
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setIsOpen(false);
  }, [closeModal]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [isOpen]);

  return (
    <div className={cls(styles.container, dropdownClassname)}>
      <button
        ref={ref}
        onClick={toggleDropDown}
        className={cls(styles.dropdown_btn, btnClassName, {
          ["btn btn-outline-secondary"]: !hideButtonStyles,
        })}
      >
        {btnContent}
      </button>
      {/* {isOpen && ( */}
      <div
        className={cls(styles.dropdown_container, dropdownWrapperClass, {
          [styles.open]: isOpen,
          [styles.close]: !isOpen,
        })}
      >
        {children}
      </div>
      {/* )} */}
    </div>
  );
};

export default Dropdown;
